var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Two-tone/Work"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M2.33679 12.8975C2.33679 12.8975 2.45513 14.3458 2.48263 14.8025C2.51929 15.415 2.75596 16.0992 3.15096 16.5742C3.70846 17.2475 4.36513 17.485 5.24179 17.4867C6.27263 17.4883 13.7685 17.4883 14.7993 17.4867C15.676 17.485 16.3326 17.2475 16.8901 16.5742C17.2851 16.0992 17.5218 15.415 17.5593 14.8025C17.586 14.3458 17.7043 12.8975 17.7043 12.8975",
    stroke: "#FFD600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M7.08002 4.44125V4.13208C7.08002 3.11542 7.90335 2.29208 8.92002 2.29208H11.0717C12.0875 2.29208 12.9117 3.11542 12.9117 4.13208L12.9125 4.44125",
    stroke: "#6842EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M9.99589 13.8985V12.8202",
    stroke: "#6842EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29163 6.99091V9.88008C3.88996 10.9342 5.80496 11.6726 7.90663 11.9651C8.15829 11.0476 8.98579 10.3751 9.99163 10.3751C10.9816 10.3751 11.8258 11.0476 12.0608 11.9734C14.1708 11.6809 16.0933 10.9426 17.7 9.88008V6.99091C17.7 5.57925 16.5641 4.44258 15.1525 4.44258H4.84746C3.43579 4.44258 2.29163 5.57925 2.29163 6.99091Z",
    stroke: "#6842EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCandidates);
export default __webpack_public_path__ + "static/media/ActiveCandidates.ff61e982204c908ec3de650276e39aa8.svg";
export { ForwardRef as ReactComponent };